import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { AiwynEditorComponent } from '@aiwyn/foundations/components';
import { SharedModule } from '@anduin/shared';
import { NgxsModule } from '@ngxs/store';
import {
  AdditionalRecipientsInputComponent,
  CollectionsAddressesComponent,
  CollectionsAutoApproveComponent,
  CollectionsBucketMessageFormComponent,
  CollectionsMessageFormComponent,
  CollectionsThrottlingComponent,
  ExcludedClientsComponent,
  InputWithVariableComponent,
  ManageExcludedClientsDialogComponent,
  OutstandingBalanceByAgeComponent,
  SequenceItemComponent,
  SequenceTriggerFormComponent,
  StatementPreviewComponent,
  TemplateRichTextEditorComponent,
  TriggerBuilderComponent,
} from './components';
import { CollectionsSettingsComponent } from './containers';
import { CommonCollectionsState } from './state';

@NgModule({
  declarations: [
    OutstandingBalanceByAgeComponent,
    SequenceItemComponent,
    StatementPreviewComponent,
    CollectionsThrottlingComponent,
    SequenceTriggerFormComponent,
    CollectionsSettingsComponent,
    ExcludedClientsComponent,
    CollectionsAutoApproveComponent,
    CollectionsAddressesComponent,
    CollectionsMessageFormComponent,
    ManageExcludedClientsDialogComponent,
    InputWithVariableComponent,
    TriggerBuilderComponent,
    CollectionsBucketMessageFormComponent,
    AdditionalRecipientsInputComponent,
    TemplateRichTextEditorComponent,
  ],
  exports: [
    OutstandingBalanceByAgeComponent,
    SequenceItemComponent,
    StatementPreviewComponent,
    CollectionsThrottlingComponent,
    SequenceTriggerFormComponent,
    CollectionsSettingsComponent,
    ExcludedClientsComponent,
    CollectionsAutoApproveComponent,
    CollectionsAddressesComponent,
    CollectionsMessageFormComponent,
    ManageExcludedClientsDialogComponent,
    InputWithVariableComponent,
    TriggerBuilderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AiwynEditorComponent,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatExpansionModule,
    MatMenuModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTableModule,
    MatTabsModule,
    MatSortModule,
    NgxsModule.forFeature([CommonCollectionsState]),
  ],
})
export class CommonCollectionsModule {}
